import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";

import useMaterial from "../../../../hooks/useMaterial";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { convertedValue } from "../../../../utils/common";
import { useDialog } from "../../../../contexts/DialogContext";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();

  const initialValues = {
    materialNameOperator: "eq",
    statusOperator: "eq",
    materialName: {},
    status: {},
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchMaterial, materialAutoSearchResults, isLoadingAutoSearch } = useMaterial();

  const [materialPayload, setMaterialPayload] = useState(currentPayload);
  const [materialOptions, setMaterialOptions] = useState([]);

  const { t } = useTranslation();

  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.materialName && Object.keys(data.materialName).length !== 0) {
        filters.push({
          fieldName: "materialId",
          fieldValue: convertedValue(data.materialName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }

      if (data.status && Object.keys(data.status).length !== 0) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      setPayload({
        ...payload,
        filters,
      });

      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMaterial = async () => {
    await autoSearchMaterial(materialPayload);
  };

  useEffect(() => {
    fetchMaterial();
  }, [materialPayload]);

  useEffect(() => {
    if (materialAutoSearchResults?.data?.length > 0) {
      setMaterialOptions((prev) => [...prev, ...materialAutoSearchResults.data]);
    }
  }, [materialAutoSearchResults]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={6} pt={8}>
          <Grid item xs={12} md={6}>
            <SearchableAutoComplete
              control={control}
              data={materialOptions}
              label="Material"
              payload={materialPayload}
              setPayload={setMaterialPayload}
              loading={isLoadingAutoSearch}
              name="materialName"
              multiple={false}
              defaultValue={{}}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <SearchableAutoComplete
              control={control}
              data={statusOptions}
              label="Status"
              payload={null}
              setPayload={null}
              loading={false}
              name="status"
              multiple={false}
              defaultValue={{}}
            />
          </Grid>
        </Grid>

        <FilterReset resetForm={reset} />
      </form>
    </FormProvider>
  );
}

export default AdvanceFilter;
